import React from "react";
import { Navigate } from "react-router-dom";
export const LoginRequired = () => {
    return React.createElement(Navigate, { to: "/login", replace: true, state: { from: window.location.href } });
};
